import { Tab } from "react-aria-components";
import type { StyledTabProps } from "./TabbedDialog.types";

/**
 * A styled tab component for use within TabbedDialog.
 * Uses react-aria-components Tab with consistent styling.
 */
const StyledTab = ({ id, children }: StyledTabProps) => {
  return (
    <Tab
      id={id}
      className="px-2 pt-2 pb-1 text-sm font-light cursor-pointer outline-hidden
        transition-colors bg-white data-selected:font-normal
        data-selected:border-gray-600 data-selected:border-b
        focus-visible:ring-2 focus-visible:ring-violet-500 focus-visible:ring-offset-1 rounded-t-sm"
    >
      {children}
    </Tab>
  );
};

export default StyledTab;
